"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _default={SET_INIT:"SET_INIT",SET_TEMP:"SET_TEMP"};exports.default=_default;


// WEBPACK FOOTER //
// ./node_modules/@fps/vue-toolkit/dist/store/temp/temp.mutationlist.js